import React, { useMemo } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { normalizeSmartScheduleData, SmartScheduleEvent } from '@/features/smartSchedule/model';
import { useQuickMoveController } from './QuickMoveContext';

export const QuickMoveEntry = ({ event, compact = false, onOpenSheet }: { event: SmartScheduleEvent; compact?: boolean; onOpenSheet?: () => void }) => {
    const controller = useQuickMoveController();
    if (!controller || (event.kind !== 'private' && event.kind !== 'general')) return null;
    return (
        <button
            type="button"
            className={compact ? 'quick-move-entry quick-move-entry--compact' : 'quick-move-entry'}
            aria-label={`${event.title} 시간·날짜 변경 메뉴`}
            aria-haspopup="dialog"
            title="시간·날짜 변경"
            onPointerDown={(event) => event.stopPropagation()}
            onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') event.stopPropagation(); }}
            onClick={(click) => {
                click.stopPropagation();
                controller.openMenu(event, click.currentTarget, onOpenSheet);
            }}
        >
            {compact ? <MoreHorizontal size={14} aria-hidden="true" /> : '시간·날짜 변경'}
        </button>
    );
};

/** 상세/목록의 원본도 기존 Smart 정규화를 거쳐 동일한 판정 경로로 들어간다. */
export const useQuickMoveRawEvent = (item: any) => {
    const controller = useQuickMoveController();
    const event = useMemo(() => normalizeSmartScheduleData({ rangeSchedules: [item] }).events[0], [item]);
    return controller && (event?.kind === 'private' || event?.kind === 'general') ? event : null;
};

export const QuickMoveRawEntry = ({ item, compact = false, onOpenSheet }: { item: any; compact?: boolean; onOpenSheet?: () => void }) => {
    const event = useQuickMoveRawEvent(item);
    return event ? <QuickMoveEntry event={event} compact={compact} onOpenSheet={onOpenSheet} /> : null;
};
